import React from 'react';
import { hydrateRoot } from 'react-dom/client';

export { render };

function render(pageContext) {
  const {
    Page,
    initialData,
    initialCoordinates,
    initialTideData,
    initialWindData,
    initialShoreReference,
    locationText,
    is404,
    isRedirect,
    redirectUrl
  } = pageContext;
  
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    console.error('Root element not found');
    return;
  }

  try {
    hydrateRoot(
      rootElement,
      <React.StrictMode>
        <Page 
          initialData={initialData}
          initialCoordinates={initialCoordinates}
          initialTideData={initialTideData}
          initialWindData={initialWindData}
          initialShoreReference={initialShoreReference}
          locationText={locationText}
          is404={is404}
          isRedirect={isRedirect}
          redirectUrl={redirectUrl}
        />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Hydration error:', error);
    // Fallback: render instead of hydrate
    import('react-dom/client').then(({ createRoot }) => {
      const root = createRoot(rootElement);
      root.render(
        <React.StrictMode>
          <Page 
            initialData={initialData}
            initialCoordinates={initialCoordinates}
            initialTideData={initialTideData}
            initialWindData={initialWindData}
            initialShoreReference={initialShoreReference}
            locationText={locationText}
            is404={is404}
            isRedirect={isRedirect}
            redirectUrl={redirectUrl}
          />
        </React.StrictMode>
      );
    });
  }
}